export type AwardPlacement = 'home_hero' | '6d_hero' | '6d_unique_card' | 'about_recognition' | 'footer' | 'home_results';

export const AWARD_NEWS_PATH = '/news/tmn-choice-awards-2026';

interface PostHogLike {
	capture: (event: string, properties?: Record<string, unknown>) => void;
}

// PostHog is loaded by the host page; do nothing if it isn't available.
export const trackAwardClick = (placement: AwardPlacement): void => {
	try {
		const posthog = (window as unknown as { posthog?: PostHogLike }).posthog;
		posthog?.capture('award_badge_clicked', { placement });
	} catch {
		// analytics must never break navigation
	}
};
